var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 15.5C11.5864 15.5 11.25 15.8366 11.25 16.2503C11.25 16.6637 11.5864 17 12 17C12.4136 17 12.75 16.6637 12.75 16.2503C12.75 15.8366 12.4136 15.5 12 15.5ZM12.5998 13.4C12.5998 13.7314 12.3312 14 11.9998 14C11.6684 14 11.3998 13.7314 11.3998 13.4V7.60009C11.3998 7.26867 11.6685 7 11.9999 7C12.3313 7 12.6 7.26868 12.6 7.60011L12.5998 13.4Z",
    fill: "#FFB500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.af55f5e0234831f77262505dc2825e9e.svg";
export { ForwardRef as ReactComponent };